import { GoDatabase } from "react-icons/go";
import { BsClipboardData } from "react-icons/bs";
import { BsCreditCard2Front } from "react-icons/bs";
import { BsDiagram3 } from "react-icons/bs";

function Capabilities() {
  return (
    <section id="services" className="services">
      <div className="container">
        <header className="section-header">
          <h2>Pratham Capabilities</h2>
          <p>Your Gateway to Unprecedented Video Analytics</p>
        </header>

        <div className="row">
          <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
            <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
              <div className="icon">
                <img
                  src="assets/img/image2.png"
                  className="img-fluid"
                  alt=""
                  width={40}
                />
              </div>
              <h4 className="title">
                <a href="">Advanced Counting Management</a>
              </h4>
              <p className="description">
                Pratham's advanced counting capabilities cover a wide range of
                elements, including people, vehicles, and various inventory
                items like carton boxes, sacks, or bags. This comprehensive
                functionality streamlines footfall, traffic and inventory
                management processes, offering real-time insights to optimize
                resource allocation and enhance operational efficiency across
                diverse sectors.
              </p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
            <div className="icon-box" data-aos="fade-up" data-aos-delay="200">
              <div className="icon">
              <img
                  src="assets/img/image.png"
                  className="img-fluid"
                  alt=""
                  width={40}
                />
              </div>
              <h4 className="title">
                <a href="">Enhanced Safety Compliance</a>
              </h4>
              <p className="description">
                Ensure workplace safety with Pratham's robust detection
                features. Detect missing personal protective equipment (PPE)
                such as helmets and vests, ensuring adherence to safety
                protocols. Early detection of fire and smoke alerts enables
                swift intervention, minimizing risks and safeguarding personnel
                and assets.
              </p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
            <div className="icon-box" data-aos="fade-up" data-aos-delay="300">
              <div className="icon">
              <img
                  src="assets/img/image3.png"
                  className="img-fluid"
                  alt=""
                  width={40}
                />
              </div>
              <h4 className="title">
                <a href="">Intelligent Surveillance and Monitoring</a>
              </h4>
              <p className="description">
                Elevate your security measures with Pratham's intelligent
                surveillance capabilities. From vehicle overspeeding detection
                to automatic number plate recognition (ANPR), get comprehensive
                monitoring to enhance safety and security. Monitor MHE for
                optimal performance and mitigate risks, while advanced facial
                recognition and blacklisted person detection further bolster
                security measures for your premises.
              </p>
            </div>
          </div>

          {/* <div className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0">
            <div className="icon-box" data-aos="fade-up" data-aos-delay="400">
              <div className="icon">
                <BsDiagram3 />
              </div>
              <h4 className="title">
                <a href="">Workflow & Business Process Automation</a>
              </h4>
              <p className="description">
                Pratham automates workflows and business processes, ensuring a
                smooth and efficient video analytics experience from start to
                finish.
              </p>
            </div>
          </div> */}
          {/* <div className="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0 mt-5">
            <div className="icon-box" data-aos="fade-up" data-aos-delay="400">
              <div className="icon">
                <i className="bx bx-world"></i>
              </div>
              <h4 className="title">
                <a href="">
                  MEET PRATHAM: Where Your Videos Become Insights, Effortlessly
                </a>
              </h4>
              <p className="description">
                Join us on this revolutionary journey where no-code meets
                limitless possibilities. With Pratham, your videos are not just
                videos; they're gateways to actionable insights, all at your
                fingertips.
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}

export default Capabilities;
